import React from "react";

import { FiMail } from "react-icons/fi";

import Button from "../../basics/Button/Button";

import styles from "./ContactContainer.module.css";

const ContactContainer = ({ showForm }) => {
  return (
    <div className={styles.contactContainer}>
      <div className="container">
        <div className="row">
          <div
            className={`col-12 col-md-12 col-lg-6 col-xl-6 ${styles.contactInfoWrapper}`}
          >
            <h2>Contact</h2>
            <p>
              Bel ons of stuur een mail, en dan nemen wij spoedig contact op met
              u.
            </p>

            <div className={styles.ctaWrapper}>
              <ul>
                <li>
                  <a
                    href="mailto:asbestattestdirect@outlook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${styles.ctaButton}  ${styles.ctaMail}`}
                  >
                    Contacteer ons! <FiMail />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {showForm ? (
            <div
              className={`col-12 col-md-12 col-lg-6 col-xl-6 ${styles.contactFormWrapper}`}
            >
              <div className={styles.formWrapper}>
                <form action="submit">
                  <h2>Stuur ons een berichtje!</h2>
                  <input
                    className={styles.formInput}
                    type="text"
                    placeholder="Email..."
                  />
                  <textarea
                    className={`${styles.formInput} ${styles.formTextArea}`}
                    rows="10"
                    placeholder="Bericht..."
                  ></textarea>
                  <Button label="Verzenden" type="submit" />
                </form>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactContainer;
